import React, { useState } from "react";
import "./BookFeaturesList.css";
import { BookFeaturesListItem } from "@tennr/frontend/components/BookFeaturesListItem";

const items = [
  {
    title: "Convert more referrals into patients",
    body: "30% of patients drop off before you even get in touch. 50% lack the right info. And your referring providers don't know what to send you. We'll help you tighten the process.",
    id: "convert",
  },
  {
    title: "Slash first-time denials",
    body: "Run a unified process from eligibility to complex benefits investigations that guarantees quality so you get paid for the work you do. You'll catch missing info upstream, before the billing team gets involved.",
    id: "slash",
  },
  {
    title: "Keep referring providers happy",
    body: "Take patients however they're sent—eFax, email, e-portal, and e-prescribe included—and provide complete visibility to referring providers every step of the way. Think 10 minutes, not 10 days.",
    id: "keep",
  },
];

export const BookFeaturesList: React.FC = () => {
  const [activeId, setActiveId] = useState("convert");

  return (
    <div className="book-features-list">
      <div className="book-features-items">
        {items.map(({ title, body, id }) => {
          return (
            <BookFeaturesListItem
              key={id}
              title={title}
              body={body}
              id={id}
              active={activeId === id}
              setActive={() => setActiveId(id)}
            />
          );
        })}
      </div>
    </div>
  );
};
